/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


window.Vue = require('vue').default;
import Lang from 'lang.js';
import VueRouter from "vue-router";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import './header';
import './scrollables/opinions-section';
import './scrollables/scrollable-section';

import routes from './router';
import store from './store';

Vue.config.productionTip = false;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('about-teachers', require('./components/AboutTeachers.vue').default);
Vue.component('card-about', require('./components/CardAbout.vue').default);
Vue.component('teacher-dialog', require('./components/TeacherDialog.vue').default);
Vue.component('jobs-container', require('./components/jobs/JobsContainer.vue').default);
Vue.component('floating-input', require('./components/forms/FloatingInput.vue').default);
Vue.component('floating-radio-button', require('./components/forms/FloatingRadioButton.vue').default);
Vue.component('floating-select-input', require('./components/forms/FloatingSelectInput.vue').default);
Vue.component('floating-textarea', require('./components/forms/FloatingTextarea.vue').default);
Vue.component('loading-button', require('./components/forms/LoadingButton.vue').default);
Vue.component('faqs-index', require('./components/faqs/FaqsIndex.vue').default);
Vue.component('stepper-wrapper', require('./wizard/steps/StepperWrapper.vue').default);
Vue.component('wizard-base', require('./wizard/WizardBase.vue').default);
Vue.component('card-courses', require('./wizard/components/CardCourses.vue').default);
Vue.component('access-marketability', require('./components/courses/AccessMarketability.vue').default);
Vue.component('brochure-form', require('./components/courses/BrochureForm.vue').default);
Vue.component('access-marketability', require('./components/courses/AccessMarketability.vue').default);
Vue.component('brochure-form', require('./components/courses/BrochureForm.vue').default);
Vue.component('stepper-wrapper', require('./wizard/steps/StepperWrapper.vue').default);
Vue.component('wizard-base', require('./wizard/WizardBase.vue').default);
Vue.component('registration-form', require('./wizard/registration/RegistrationForm.vue').default);
Vue.component('contact-form', require('./components/contact/ContactForm.vue').default);
Vue.component('progress-file-upload', require('./components/forms/ProgressFileUpload.vue').default);

const messages = Object.entries(window.messages[window.appLocale]).reduce(
    (agg, [key, value]) => {
        agg[`${window.appLocale}.${key}`] = value;
        return agg;
    },
    {}
);
Vue.prototype.$trans = new Lang({
    messages,
    locale: window.appLocale
});


// Currency filter plugin
require('./plugins/currency');


Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    base: window.appLocale,
    routes
});
window.router = router;

Vue.use(VueToast, {
    position: 'bottom'
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
    el: '#app',
    router,
    store
});
window.app = app;
